let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2F69B"), load("c6MKV"), load("aZinD"), load("joJy8"), load("aHE9G"), load("5K3iw")]).then(() => parcelRequire('lhpIB'));